/* Vibes gift guard + claim line + value strip + mobile perf. Removes Bonus Wallpapers everywhere (cart + full bundle-card gift row incl. image & price + gift counters) -> 1x = 1 gift (cloth), 2x = 2 gifts (cloth + tripod). Each remaining gift max qty 1. Tripod only with 2+ projectors. Never touches projector or paid add-ons. */
(function(){
  var CLOTH=53525778235757,WALLPAPERS=53525777678701,TRIPOD=53525777777005,SHIPPING=53525778071917;
  var GIDS=[CLOTH,WALLPAPERS,TRIPOD,SHIPPING];
  var PROJ=[52807373685101,52842186703213,52842200596845];
  var busy=false;
  function cartUrl(){return ((window.routes&&window.routes.cart_url)||'/cart')+'.js';}
  function changeUrl(){return (window.routes&&window.routes.cart_change_url)||'/cart/change.js';}
  function injectCSS(){
    if(document.getElementById('vpr-perf-css'))return;
    var s=document.createElement('style');s.id='vpr-perf-css';
    s.textContent='@media (max-width:640px){.vpr-hero-grid>div:first-child>div:first-child{height:44vh !important;min-height:220px;aspect-ratio:auto !important;}.vpr-hero-grid>div:first-child>div:first-child img{object-position:center;}.vpr-hero-grid{padding-top:16px !important;padding-bottom:22px !important;gap:20px !important;}.vpr-value-strip{margin:10px 0 !important;padding:10px 13px !important;}}';
    (document.head||document.documentElement).appendChild(s);
  }
  function swapContents(sections){
    try{
      var html=sections&&sections['cart-drawer'];if(!html)return;
      var doc=new DOMParser().parseFromString(html,'text/html');
      var fresh=doc.getElementById('CartDrawer-CartItems'),cur=document.getElementById('CartDrawer-CartItems');
      if(fresh&&cur)cur.innerHTML=fresh.innerHTML;
      var fb=doc.querySelector('.cart-drawer__footer'),cb=document.querySelector('.cart-drawer__footer');
      if(fb&&cb)cb.innerHTML=fb.innerHTML;
      var bb=doc.querySelector('.cart-count-bubble'),cbb=document.querySelector('.cart-count-bubble');
      if(bb&&cbb)cbb.innerHTML=bb.innerHTML;
    }catch(e){}
  }
  function change(key,qty,then){
    fetch(changeUrl(),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:qty,sections:'cart-drawer',sections_url:window.location.pathname})}).then(function(r){return r.json();}).then(function(res){if(res&&res.sections)swapContents(res.sections);then();}).catch(function(){then();});
  }
  function enforce(){
    if(busy)return;
    fetch(cartUrl(),{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){
      if(!c||!c.items)return;
      var pq=0;c.items.forEach(function(it){if(PROJ.indexOf(it.variant_id)>-1)pq+=it.quantity;});
      var ops=[];
      c.items.forEach(function(it){
        if(GIDS.indexOf(it.variant_id)===-1)return;
        if(it.variant_id===WALLPAPERS){ops.push({key:it.key,qty:0});return;}
        if(it.variant_id===TRIPOD&&pq<2){ops.push({key:it.key,qty:0});return;}
        if(it.quantity>1)ops.push({key:it.key,qty:1});
      });
      if(!ops.length){decorate();return;}
      busy=true;
      (function next(i){if(i>=ops.length){busy=false;decorate();return;}change(ops[i].key,ops[i].qty,function(){next(i+1);});})(0);
    }).catch(function(){});
  }
  function pageGifts(){
    try{
      var roots=document.querySelectorAll('[id^="vpr-bundles-"]');
      if(!roots.length)return false;
      var any=false;
      roots.forEach(function(root){
        if(!root.children.length)return;
        any=true;
        var all=root.querySelectorAll('*');
        for(var i=0;i<all.length;i++){
          var el=all[i];if(el.children.length!==0)continue;
          var t=(el.textContent||'').toLowerCase();
          if(t.indexOf('wallpaper')>-1){
            var row=el;
            while(row&&row!==root){if(row.querySelector&&row.querySelector('img'))break;row=row.parentElement;}
            var target=(row&&row!==root)?row:(el.parentElement||el);
            if(target&&target.style.display!=='none')target.style.display='none';
          }
        }
        var cs=root.querySelectorAll('*');
        for(var j=0;j<cs.length;j++){var e=cs[j];if(e.children.length!==0)continue;if(e.getAttribute('data-vpr-ct')==='1')continue;var m=(e.textContent||'').match(/\+\s*(\d+)\s+free gifts/i);if(m){var n=parseInt(m[1],10);var nn=n>1?n-1:n;e.textContent=e.textContent.replace(/\+\s*\d+\s+free gifts/i,'+'+nn+' free gifts');e.setAttribute('data-vpr-ct','1');}}
      });
      return any;
    }catch(e){return false;}
  }
  function valueStrip(){
    try{
      if(document.querySelector('.vpr-value-strip'))return true;
      var els=document.querySelectorAll('h1,h2,p');var a=null;
      for(var i=0;i<els.length;i++){var t=els[i].textContent||'';if(t.indexOf('under 60')>-1||t.indexOf('130-inch')>-1){if(!a||t.length<(a.textContent||'').length)a=els[i];}}
      if(!a||!a.parentNode)return false;
      var d=document.createElement('div');d.className='vpr-value-strip';
      d.style.cssText='margin:12px 0;padding:11px 14px;background:#eef4f8;border:1px solid #d5e3ec;border-radius:12px;';
      d.innerHTML='<span style=\"font-size:clamp(13px,3.4vw,15px);color:#23282d;font-weight:600;line-height:1.45;\">Comparable projectors start at <s style=\"color:#9aa5ad;font-weight:600;\">$300+</s>. Yours today: <strong style=\"color:#111;font-weight:800;\">$89.99</strong> <span style=\"display:inline-flex;align-items:center;vertical-align:middle;font-size:9.5px;font-weight:800;letter-spacing:.03em;text-transform:uppercase;color:#fff;background:#4E7A9B;padding:3px 8px;border-radius:100px;white-space:nowrap;\">Limited time</span></span>';
      a.parentNode.insertBefore(d,a.nextSibling);return true;
    }catch(e){return false;}
  }
  function claimLine(){
    try{
      var bar=document.querySelector('.cart-progress.cart-checkpoints');if(!bar||!bar.parentNode)return;
      var prog=bar.querySelector('.cart-progress__bar__progress');
      var pw=prog?parseFloat((prog.style.width||'0'))||0:0;
      var free=false,exp=false;
      bar.querySelectorAll('.cart-progress__bar__badge').forEach(function(b){
        var pos=parseFloat((b.style.getPropertyValue('--position')||'999'))||999;
        if(pos>pw+0.5)return;
        var lab=b.querySelector('.cart-checkpoints__label');
        var t=(lab?lab.textContent:'').toLowerCase();
        if(t.indexOf('priorit')>-1||t.indexOf('expedit')>-1||t.indexOf('express')>-1||t.indexOf('fast')>-1)exp=true;
        else if(t.indexOf('ship')>-1)free=true;
      });
      var msg=exp?'Free priority shipping unlocked \u2014 claim it at checkout':(free?'Free shipping unlocked \u2014 claim it at checkout':'');
      var line=bar.parentNode.querySelector('.vpr-claim-line');
      if(!msg){if(line)line.remove();return;}
      if(line&&line.getAttribute('data-msg')===msg)return;
      if(!line){
        line=document.createElement('div');line.className='vpr-claim-line';
        line.style.cssText='display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:6px;margin:30px 4px 6px;padding-top:11px;border-top:1px solid #e4e9ee;font-size:clamp(11.5px,3.4vw,13px);font-weight:700;color:#2f5a78;line-height:1.3;text-align:center;text-wrap:pretty;';
        bar.parentNode.insertBefore(line,bar.nextSibling);
      }
      line.setAttribute('data-msg',msg);
      line.innerHTML='<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.4\" style=\"flex-shrink:0;\"><rect x=\"1\" y=\"3\" width=\"15\" height=\"13\" rx=\"1\"></rect><path d=\"M16 8h4l3 3v5h-7z\"></path><circle cx=\"5.5\" cy=\"18.5\" r=\"2.5\"></circle><circle cx=\"18.5\" cy=\"18.5\" r=\"2.5\"></circle></svg><span>'+msg+'</span>';
    }catch(e){}
  }
  function decorate(){
    document.querySelectorAll('.quantity__input[data-quantity-variant-id]').forEach(function(inp){
      if(GIDS.indexOf(parseInt(inp.getAttribute('data-quantity-variant-id'),10))===-1)return;
      var row=inp.closest('.cart-item')||inp.closest('li');if(!row||row.getAttribute('data-vpr')==='1')return;
      row.setAttribute('data-vpr','1');
      var plus=row.querySelector('button[name=plus], .quantity__button--plus');
      if(plus){plus.setAttribute('disabled','disabled');plus.style.opacity='0.3';plus.style.pointerEvents='none';plus.style.cursor='not-allowed';}
      var host=row.querySelector('.cart-item__details')||row;
      if(host&&!row.querySelector('.vpr-gift-note')){
        var n=document.createElement('div');n.className='vpr-gift-note';
        n.style.cssText='display:inline-flex;align-items:center;gap:6px;margin-top:7px;font-size:11.5px;font-weight:600;color:#3D6280;background:#e0eef5;border:1px solid #cfe0ea;padding:4px 10px;border-radius:100px;line-height:1.2;';
        n.innerHTML='<svg width=\"12\" height=\"12\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" style=\"flex-shrink:0;\"><polyline points=\"20 6 9 17 4 12\"></polyline></svg><span>Limit reached \u2014 1 free gift per order</span>';
        host.appendChild(n);
      }
    });
    claimLine();
  }
  function ping(){setTimeout(enforce,250);setTimeout(enforce,1200);}
  function trig(u){return typeof u==='string'&&(u.indexOf('/cart/add')>-1||u.indexOf('/cart/update')>-1||u.indexOf('/cart/clear')>-1);}
  var of=window.fetch;
  window.fetch=function(){var a=arguments,u=a[0]&&a[0].url?a[0].url:a[0];var p=of.apply(this,a);if(trig(u)){try{p.then(ping);}catch(e){}}return p;};
  var oo=XMLHttpRequest.prototype.open,os=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(m,u){this._vpru=u;return oo.apply(this,arguments);};
  XMLHttpRequest.prototype.send=function(){var s=this;if(trig(s._vpru||''))s.addEventListener('load',ping);return os.apply(this,arguments);};
  function observe(){
    var target=document.getElementById('CartDrawer');
    if(!target)return false;
    try{new MutationObserver(function(){clearTimeout(window.__vprD);window.__vprD=setTimeout(decorate,40);}).observe(target,{childList:true,subtree:true});}catch(e){}
    return true;
  }
  var bundlesObserved=false;
  function observeBundles(){
    var r=document.querySelector('[id^="vpr-bundles-"]');
    if(!r)return false;
    if(bundlesObserved)return true;
    try{new MutationObserver(function(){clearTimeout(window.__vprG);window.__vprG=setTimeout(pageGifts,60);}).observe(r,{childList:true,subtree:true});bundlesObserved=true;}catch(e){}
    return true;
  }
  function boot(){
    injectCSS();
    decorate();
    if(!observe()){var t=new MutationObserver(function(){if(observe()){t.disconnect();decorate();}});try{t.observe(document.documentElement,{childList:true,subtree:true});}catch(e){}}
    var sn=0,siv=setInterval(function(){valueStrip();pageGifts();observeBundles();if(++sn>60)clearInterval(siv);},800);
    valueStrip();pageGifts();observeBundles();
  }
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  setInterval(enforce,5000);
})();
